export const AUDIO_FORMATS = ["mp3", "ogg", "wav"];
export const VIDEO_FORMATS = ["mp4", "mov"];
export const IMAGE_FORMATS = ["jpg", "png", "tiff", "heic", "jpeg"];
